import { transliterate } from "@/utils/translitUtils";

/**
 * Возвращает уникальный код на основе имени, добавляя суффикс _1, _2 ...
 * Поддерживает:
 *  - existing = массив строк кодов
 *  - existing = массив записей с полями { id, code }
 * Параметр excludeId применяется только если переданы записи с id.
 */
export function generateUniqueCode(
  name,
  existing = [],
  excludeId = null
) {
  const baseCode = transliterate(name) || "";
  let code = baseCode;
  let suffix = 1;

  // Нормализуем список существующих кодов
  let existingCodes = [];
  if (Array.isArray(existing)) {
    if (existing.length === 0) {
      existingCodes = [];
    } else if (typeof existing[0] === "string") {
      existingCodes = existing;
    } else if (
      typeof existing[0] === "object" &&
      existing[0] !== null
    ) {
      const records =
        excludeId == null
          ? existing
          : existing.filter((rec) => rec.id !== excludeId);
      existingCodes = records.map((rec) => rec.code);
    }
  }

  // Добавляем суффикс, если такой код уже есть
  while (existingCodes.includes(code)) {
    code = `${baseCode}_${suffix}`;
    suffix++;
  }

  return code;
}
